
export default {
  name: "IconStar"
}
